// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__Diz9a","footer":"ModalUpdate_footer__11aDY"};